import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface MaintenanceState {
  isMaintenanceMode: boolean
  maintenanceMessage: string
  estimatedDuration: string
  setMaintenanceMode: (enabled: boolean) => void
  setMaintenanceMessage: (message: string) => void
  setEstimatedDuration: (duration: string) => void
  forceLogoutAll: () => void
}

export const useMaintenanceStore = create<MaintenanceState>()(
  persist(
    (set, get) => ({
      isMaintenanceMode: false, // Modo manutenção desabilitado por padrão
      maintenanceMessage: 'Estamos realizando algumas atualizações importantes no momento.',
      estimatedDuration: 'Voltaremos em breve com melhorias incríveis!',
      
      setMaintenanceMode: (enabled) => {
        set({ isMaintenanceMode: enabled })
        
        // Se ativado, força logout de todos os usuários
        if (enabled) {
          get().forceLogoutAll()
        }
      },
      
      setMaintenanceMessage: (message) => set({ maintenanceMessage: message }),
      
      setEstimatedDuration: (duration) => set({ estimatedDuration: duration }),
      
      forceLogoutAll: () => {
        // Limpa todos os dados de autenticação do localStorage
        localStorage.removeItem('ephemeral-cards-auth')
        localStorage.removeItem('ephemeral-cards-session')
        localStorage.removeItem('sb-' + import.meta.env.VITE_SUPABASE_URL?.split('//')[1] + '-auth-token')
        
        // Força reload da página para limpar o estado
        if (typeof window !== 'undefined') {
          window.location.reload()
        }
      }
    }),
    {
      name: 'maintenance-storage',
      partialize: (state) => ({
        isMaintenanceMode: state.isMaintenanceMode,
        maintenanceMessage: state.maintenanceMessage,
        estimatedDuration: state.estimatedDuration
      })
    }
  )
)

// Hook para verificar se o modo manutenção está ativo
export const useMaintenanceCheck = () => {
  const { isMaintenanceMode } = useMaintenanceStore()
  
  // Verifica também a variável de ambiente como fallback (tem prioridade)
  const envMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true'
  
  return envMaintenanceMode || isMaintenanceMode
}

// Hook para forçar modo manutenção em tempo real
export const useMaintenanceForce = () => {
  const { setMaintenanceMode, forceLogoutAll } = useMaintenanceStore()
  
  const forceMaintenance = (enabled: boolean, message?: string, duration?: string) => {
    // Atualiza mensagens se fornecidas
    if (message) useMaintenanceStore.getState().setMaintenanceMessage(message)
    if (duration) useMaintenanceStore.getState().setEstimatedDuration(duration)
    
    // Ativa/desativa o modo
    setMaintenanceMode(enabled)
    
    // Se ativado, força logout imediatamente
    if (enabled) {
      console.log('🔧 Modo manutenção FORÇADO - Desconectando todos os usuários')
      forceLogoutAll()
    } else {
      console.log('✅ Modo manutenção DESATIVADO - Sistema normalizado')
    }
    
    return enabled
  }
  
  return { forceMaintenance }
}
